// extracted by mini-css-extract-plugin
module.exports = {"modal":"ForcePasswordChangeModal_modal__3kDwS","passwordIcon":"ForcePasswordChangeModal_passwordIcon__1Oi78"};